import { motion } from "framer-motion";
import styled from "styled-components";

export const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  font-size: ${(props) => props.theme.fontSizes[2]}px;
`;

export const UploadWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
/* The dropzone was a 200px-tall full-width well that dwarfed the thumbnails
   sitting next to it. Sized to match a preview tile so the row reads as one
   set of items, and given a real hover state instead of a static SVG dash. */
export const UploadField = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  position: relative;
  height: 100px;
  width: 150px;
  flex: 0 0 150px;
  box-sizing: border-box;
  padding: 12px;
  text-align: center;
  border: 1px dashed ${(props) => props.theme.colors.borderStrong};
  background: ${(props) => props.theme.colors.surfaceRaised};
  border-radius: ${(props) => props.theme.radii.md}px;
  margin-bottom: 0;
  margin-right: 0;
  transition: border-color 120ms ease, background 120ms ease;
  cursor: pointer;

  &:hover {
    border-color: ${(props) => props.theme.colors.primary};
    background: ${(props) => props.theme.colors.surfaceHover};
  }
`;

export const UploadedImages = styled.div`
  display: flex;
  img {
    width: 100px;
  }
`;

export const ImgWrapper = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 200px;
  width: 100%;
  border: 1px dashed #eaeaea;
  border-radius: 7px;
  transition: 0.3s;
`;

export const Input = styled.input`
  position: relative;
  z-index: 999;
  width: 100%;
  height: 100%;
  opacity: 0;
`;

export const ButtonsWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const UWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 25px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  /* background: rgba(255, 255, 255, 0.5); */
`;
export const Icon = styled.div`
  margin-bottom: ${(props) => props.theme.space[2]}px;
`;
export const Text = styled.span`
  color: #8e8e8e;
  font-size: 14px;
  max-width: 217px;
  text-align: center;
  line-height: 20px;
`;

export const UploadedImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

/* Previews were a single stacked column with a 36px thumbnail and REMOVE
   pushed to the far edge of a full-width row, so an uploaded image read as a
   stray chip rather than a picture. Card-shaped tiles instead. */
export const ImagesPreview = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-start;
`;

export const Image = styled.img`
  width: 150px;
  height: 100px;
  object-fit: cover;
  border-radius: ${(props) => props.theme.radii.md}px;
  border: 1px solid ${(props) => props.theme.colors.border};
  display: block;
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  width: 150px;
  border-bottom: none;
  padding: 0;

  .btn {
    width: 100%;
    justify-content: center;
  }
`;
